import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1rem;
`;

export const item = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	border-radius: 5px;
	padding: 1rem;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
		> b {
			font-size: 1.3rem;
			font-family: nunito-bold;
			color: ${color.interface.darkgray};
		}
	}
`;

export const imgs = styled.div`
	width: 100%;
	box-sizing: border-box;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	> img {
		width: 100%;
		max-height: 100%;
		min-height: 100%;
		height: 100%;

		border-radius: 5px;
		object-fit: cover;
	}
`;

export const btnsItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 25px;
		color: ${color.interface.darkgray};
	}
`;

export const colorContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: flex-start;
`;

export const ballColor = styled.div<{ $color: string }>`
	width: 1rem;
	height: 1rem;
	border-radius: 0.5rem;
	background-color: ${(props) => props.$color};
`;
